// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `angular-cli.json`.

export const environmentBase = {
  production: false,

  firebase: {
    apiKey: "AIzaSyBKqW8m1qbM2_2sRfhvoraNZYyFLvSPtuY",
    authDomain: "roche-client-app.firebaseapp.com",
    databaseURL: "https://roche-client-app.firebaseio.com",
    projectId: "roche-client-app",
    storageBucket: "roche-client-app.appspot.com",
    messagingSenderId: "913088007333"
  },
  httpFunctionsHost: `https://us-central1-roche-client-app.cloudfunctions.net`,
  analyticsUrl: 'https://console.firebase.google.com/project/roche-client-app/analytics/app/android:com.qapint.roche/overview%3Ft=1&cs=app.m.dashboard.overview&g=1'
};



// WEBPACK FOOTER //
// C:/xampp/htdocs/roche/roche/src/environments/environment.base.ts